import React from 'react';

function Chip({
  children,
  className = '',
  color = 'default',
  icon,
  label,
  size = 'medium',
  variant = 'neutral',
}) {
  const tone = color === 'error' ? 'danger' : color === 'default' ? 'neutral' : color;
  return (
    <span className={[
      'custom-chip',
      `custom-chip--${tone}`,
      variant === 'outlined' ? 'custom-chip--outlined' : '',
      `custom-chip--${size}`,
      className,
    ].filter(Boolean).join(' ')}>
      {icon && <span className="custom-chip__icon">{icon}</span>}
      {label ?? children}
    </span>
  );
}

export default Chip;
